import TravelDestinationPageWrapper from './TravelDestinationPageWrapper';

export default TravelDestinationPageWrapper;
